// HomePage.js
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import ErrorSnackbar from '../components/ErrorSnackbar.js';
import SuccessSnackbar from '../components/SuccessSnackbar.js';
import MainLayout from '../layouts/MainLayout.js';
import useSnackbarQueue from '../hooks/useSnackbarQueue.js';
import { artworkAttachmentLabel } from '../utils/artworkAttachmentLabel.js';
import { ArtworkViewer } from '../components/ArtworkViewer.js';
import {
    getartwork,
    artwork_post,
    artwork_comment
} from "../services/api.js";
import { toast } from "react-toastify";
export const Home = () => {
    const token = useParams();
    const [artall, setartall] = useState();
    const [proof, setproof] = useState(false);
    const [pdfindex, setpdfindex] = useState(0);
    const [rejectModal, setRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const [pendingRejectId, setPendingRejectId] = useState(null);
    const [approveModal, setApproveModal] = useState(false);
    const [pendingApproveId, setPendingApproveId] = useState(null);
    const [clientName, setClientName] = useState("");
    const [submitAttempted, setSubmitAttempted] = useState(false);
    const [commentName, setCommentName] = useState("");
    const [commentText, setCommentText] = useState("");
    const getartwork_click = async () => {
        const res = await getartwork(token);
        console.log(res.data.Message);
        
        setartall(res.data.AllData);
        const list = res.data.AllData?.OrderArtworkAttachment || [];
        const pending = list.findIndex((a) => Number(a.Approve) === 2);
        if (pending >= 0) setpdfindex(pending);
    }
    const getartwork_click2 = async () => {
        const res = await getartwork(token);
        console.log(res.data.Message);
        if (res.data.Message == "EXPIRED") {
            setproof(true);
        } else {
            setproof(false);
        }
    }
    const handlepdf = (a) => {
        setpdfindex(a)
        // alert(a);
    }
    const {
        ExceptionError,
        successMessages,
        handleExceptionError,
        handleExceptionSuccessMessages,
        clearErrors,
        clearSuccess,
    } = useSnackbarQueue();
    const artwork_api = async (artworkid, status, comment = "", name = "") => {
        try {
            console.log(artall);
            const res = await artwork_post(artworkid, status, artall.OrderData, artall.OrderDetails, comment, name);
            if (res.status == 200) {
                console.log(res);
                setartall((prv) => {
                    const updatedOrderArtworkAttachment = [...prv.OrderArtworkAttachment];
                    updatedOrderArtworkAttachment[pdfindex] = {
                        ...updatedOrderArtworkAttachment[pdfindex],
                        Approve: status,
                        ...(status === 0 && { Remark: comment }),
                    };
                    return {
                        ...prv,
                        OrderArtworkAttachment: updatedOrderArtworkAttachment
                    };
                });
                handleExceptionSuccessMessages("Response submit");
                getartwork_click();
            }
        } catch (error) {
            handleExceptionError("Response not submited");
            console.error("Error fetching data:", error);
        }
    }

    const handleRejectClick = (artworkid) => {
        setPendingRejectId(artworkid);
        setRejectReason("");
        setClientName("");
        setSubmitAttempted(false);
        setRejectModal(true);
    }

    const handleRejectSubmit = async () => {
        setSubmitAttempted(true);
        if (!rejectReason.trim() || !clientName.trim()) return;
        setRejectModal(false);
        await artwork_api(pendingRejectId, 0, rejectReason.trim(), clientName.trim());
        setPendingRejectId(null);
        setRejectReason("");
        setClientName("");
        setSubmitAttempted(false);
    }

    const handleRejectCancel = () => {
        setRejectModal(false);
        setPendingRejectId(null);
        setRejectReason("");
        setClientName("");
        setSubmitAttempted(false);
    }

    const handleApproveClick = (artworkid) => {
        setPendingApproveId(artworkid);
        setClientName("");
        setSubmitAttempted(false);
        setApproveModal(true);
    }

    const handleApproveSubmit = async () => {
        setSubmitAttempted(true);
        if (!clientName.trim()) return;
        setApproveModal(false);
        await artwork_api(pendingApproveId, 1, "", clientName.trim());
        setPendingApproveId(null);
        setClientName("");
        setSubmitAttempted(false);
    }

    const handleApproveCancel = () => {
        setApproveModal(false);
        setPendingApproveId(null);
        setClientName("");
        setSubmitAttempted(false);
    }
    useEffect(()=> {
        getartwork_click();
        getartwork_click2();
    },[]) 

    return (
        <>
            {proof==false ? (
                <>
        <ErrorSnackbar errorMessages={ExceptionError} onClearErrors={clearErrors} />
        <SuccessSnackbar successMessages={successMessages} onclearSuccess={clearSuccess} />
            <MainLayout orderId={artall?.OrderData}>
            <section className="bebranded_artwork_section">
                <div className="container">
                    <div className="bebranded_artwork_part">
                        <div className="bebranded_artwork_part_list">
                            <h3>Artworks</h3>
                            <p style={{ fontFamily: "poppins", fontSize: "13px", color: "#555" }}>
                              Order #{artall?.OrderData}
                              {artall?.OrderStatus ? ` · ${artall.OrderStatus}` : ""}
                            </p>
                            <div className="artwork_data_wrapper">
                                        {(artall?.OrderArtworkAttachment || [])
                                          .map((item, index) => ({ item, index }))
                                          .sort((a, b) => (a.item.Approve === 2 ? 0 : 1) - (b.item.Approve === 2 ? 0 : 1))
                                          .map(({ item, index }) => (
                                    <div className={`${pdfindex == index && "active "}" artwork_listing "`} onClick={() => handlepdf(index)} key={item.OrderArtworkAttachmentID || index}>
                                        <span>{item.ProductName ? `${item.ProductName} — ` : ""}{artworkAttachmentLabel(item.Attachment)}</span>
                                        <span style={{ display: "block", fontSize: "12px", marginTop: "4px", color: item.Approve === 1 ? "#198754" : item.Approve === 0 ? "#dc3545" : "#b8860b" }}>
                                          {item.Approve === 1 ? "Approved" : item.Approve === 0 ? "Changes required" : "Awaiting approval"}
                                        </span>
                                </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="bebranded_artwork_part bebranded_artwork_part2">
                        <div className="bebranded_artwork_part2_img">
                            <ArtworkViewer filePath={artall?.OrderArtworkAttachment?.[pdfindex]?.Attachment} />
                        </div>
                        <div className="button_div_art">
                            {artall?.OrderArtworkAttachment[pdfindex]?.Approve == 2 && (                            
                                            <><button onClick={() => handleApproveClick(artall?.OrderArtworkAttachment[pdfindex].OrderArtworkAttachmentID)}>Approve</button><button onClick={() => handleRejectClick(artall?.OrderArtworkAttachment[pdfindex].OrderArtworkAttachmentID)}>Not Approved</button></>
                            )}
                        </div>
                            {artall?.OrderArtworkAttachment[pdfindex]?.Approve == 1 && (
                            <div className="button_div_art" style={{justifyContent:'center', marginTop:'-40px'}}>
                                <><p style={{fontFamily:'poppins', color:'green', textAlign:'center'}}>Artwork approved</p></></div>
                            )}
                            {artall?.OrderArtworkAttachment[pdfindex]?.Approve == 0 && (
                            <div className="button_div_art" style={{justifyContent:'center', marginTop:'-40px', flexDirection:'column', alignItems:'center', gap:'6px'}}>
                                <p style={{fontFamily:'poppins', color:'red', textAlign:'center', margin:0}}>Changes required</p>
                                {artall?.OrderArtworkAttachment[pdfindex]?.Remark && (
                                    <div style={{
                                        backgroundColor:'#fff5f5',
                                        border:'1px solid #f5c6cb',
                                        borderRadius:'6px',
                                        padding:'10px 16px',
                                        maxWidth:'480px',
                                        width:'100%',
                                    }}>
                                        <p style={{fontFamily:'poppins', fontSize:'13px', color:'#555', margin:'0 0 4px', fontWeight:600}}>Remark:</p>
                                        <p style={{fontFamily:'poppins', fontSize:'14px', color:'#333', margin:0, wordBreak:'break-word'}}>{artall?.OrderArtworkAttachment[pdfindex]?.Remark}</p>
                                    </div>
                                )}
                            </div>
                            )}
                        <div className="proof-chat">
                          <h3>Comments</h3>
                          <div className="proof-chat-list">
                            {(artall?.Comments || []).length === 0 && (
                              <p className="proof-chat-empty">No comments yet. Send a note about this artwork.</p>
                            )}
                            {(artall?.Comments || []).map((c) => (
                              <div
                                key={c.OrderArtworkCommentID}
                                className={`proof-bubble ${c.AuthorRole === "admin" ? "admin" : ""}`}
                              >
                                <strong>
                                  {c.AuthorName}
                                  <span className="proof-role">{c.AuthorRole === "admin" ? "BeBranded" : "Customer"}</span>
                                </strong>
                                <p>{c.Message}</p>
                              </div>
                            ))}
                          </div>
                          <form
                            className="proof-chat-form"
                            onSubmit={async (e) => {
                              e.preventDefault();
                              if (!commentName.trim() || !commentText.trim()) return;
                              await artwork_comment(artall?.OrderData, commentName.trim(), commentText.trim());
                              setCommentText("");
                              getartwork_click();
                            }}
                          >
                            <input
                              value={commentName}
                              onChange={(e) => setCommentName(e.target.value)}
                              placeholder="Your name"
                            />
                            <textarea
                              value={commentText}
                              onChange={(e) => setCommentText(e.target.value)}
                              placeholder="Write a comment"
                              rows={2}
                            />
                            <button type="submit">Send</button>
                          </form>
                        </div>
                    </div>
                </div>
            </section>
            </MainLayout>

            {/* Changes Required Modal */}
            {rejectModal && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: '#fff', borderRadius: '10px', padding: '32px',
                        width: '100%', maxWidth: '440px', fontFamily: 'poppins', boxShadow: '0 8px 30px rgba(0,0,0,0.15)'
                    }}>
                        <h3 style={{ margin: '0 0 8px', color: '#222' }}>Changes Required</h3>
                        <p style={{ margin: '0 0 16px', color: '#666', fontSize: '14px' }}>Please provide us with the changes you require.</p>

                        <input
                            type="text"
                            value={clientName}
                            onChange={(e) => setClientName(e.target.value)}
                            placeholder="Enter your name..."
                            style={{
                                width: '100%', padding: '10px 12px', borderRadius: '6px',
                                border: '1px solid #ccc', fontFamily: 'poppins', fontSize: '14px',
                                boxSizing: 'border-box', outline: 'none', marginBottom: '12px'
                            }}
                        />
                        {submitAttempted && clientName.trim() === "" && (
                            <p style={{ margin: '-6px 0 10px', color: '#e53935', fontSize: '12px' }}>Please enter your name.</p>
                        )}

                        <textarea
                            rows={4}
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            placeholder="Enter changes here..."
                            style={{
                                width: '100%', padding: '10px 12px', borderRadius: '6px',
                                border: '1px solid #ccc', fontFamily: 'poppins', fontSize: '14px',
                                resize: 'vertical', boxSizing: 'border-box', outline: 'none'
                            }}
                        />
                        {submitAttempted && rejectReason.trim() === "" && (
                            <p style={{ margin: '6px 0 0', color: '#e53935', fontSize: '12px' }}>Please enter changes so we can edit your artwork.</p>
                        )}

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                            <button
                                onClick={handleRejectCancel}
                                style={{
                                    padding: '9px 20px', borderRadius: '6px', border: '1px solid #ccc',
                                    background: '#fff', fontFamily: 'poppins', cursor: 'pointer', fontSize: '14px'
                                }}
                            >Cancel</button>
                            <button
                                onClick={handleRejectSubmit}
                                style={{
                                    padding: '9px 20px', borderRadius: '6px', border: 'none',
                                    background: '#e53935',
                                    color: '#fff', fontFamily: 'poppins', cursor: 'pointer', fontSize: '14px'
                                }}
                            >Submit Changes</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Approve Modal */}
            {approveModal && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: '#fff', borderRadius: '10px', padding: '32px',
                        width: '100%', maxWidth: '440px', fontFamily: 'poppins', boxShadow: '0 8px 30px rgba(0,0,0,0.15)'
                    }}>
                        <h3 style={{ margin: '0 0 8px', color: '#222' }}>Approve Artwork</h3>
                        <p style={{ margin: '0 0 16px', color: '#666', fontSize: '14px' }}>Please enter your name to confirm approval.</p>

                        <input
                            autoFocus
                            type="text"
                            value={clientName}
                            onChange={(e) => setClientName(e.target.value)}
                            placeholder="Enter your name..."
                            style={{
                                width: '100%', padding: '10px 12px', borderRadius: '6px',
                                border: '1px solid #ccc', fontFamily: 'poppins', fontSize: '14px',
                                boxSizing: 'border-box', outline: 'none'
                            }}
                        />
                        {submitAttempted && clientName.trim() === "" && (
                            <p style={{ margin: '6px 0 0', color: '#e53935', fontSize: '12px' }}>Please enter your name to approve.</p>
                        )}

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                            <button
                                onClick={handleApproveCancel}
                                style={{
                                    padding: '9px 20px', borderRadius: '6px', border: '1px solid #ccc',
                                    background: '#fff', fontFamily: 'poppins', cursor: 'pointer', fontSize: '14px'
                                }}
                            >Cancel</button>
                            <button
                                onClick={handleApproveSubmit}
                                style={{
                                    padding: '9px 20px', borderRadius: '6px', border: 'none',
                                    background: '#2e7d32',
                                    color: '#fff', fontFamily: 'poppins', cursor: 'pointer', fontSize: '14px'
                                }}
                            >Confirm Approval</button>
                        </div>
                    </div>
                </div>
            )}
            </>
            ) : (
                <>
                <div style={{height:'100vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <h1 style={{ fontFamily: 'poppins', color: '#01aef0', textAlign: 'center', fontSize:'40px' }}>Link Expired</h1>
                </div>
                </>
            )}
        </>
    );
};
